import { Space, Typography } from 'antd'
import { useAuthContext } from 'context/AuthContext'
import { Permission } from '@cims-online/shared'

const Home: React.VFC<{
  hasWorkflows?: boolean
  projectId?: string
  projectName?: string | null
  workflowsLoading?: boolean
}> = ({
  hasWorkflows = false,
  workflowsLoading = false,
  projectId,
  projectName,
}) => {
  const { user } = useAuthContext()
  const hasModuleAccess =
    !!user &&
    (hasWorkflows ||
      user.someAuthorized(Permission.basics, projectId).authorized)

  return (
    <Space direction="vertical">
      {projectName ? (
        <>
          <Typography.Paragraph strong>
            Welcome to {projectName}
            {!!user && <>, {user.username}</>}
          </Typography.Paragraph>
          {hasModuleAccess && (
            <Typography.Paragraph>
              Open the side menu and select a module to get started
            </Typography.Paragraph>
          )}
          {!hasModuleAccess && !workflowsLoading && (
            <>
              <Typography.Paragraph>
                You do not have permission to access any modules
              </Typography.Paragraph>
              <Typography.Paragraph>
                Please reach out to your Horrocks contact point. They will need
                to give you a role or specific permissions to access any modules
              </Typography.Paragraph>
              <Typography.Paragraph>
                When permission has been granted, you may need to reload the
                page
              </Typography.Paragraph>
            </>
          )}
        </>
      ) : (
        <Typography.Paragraph strong>
          Select a project above to get started
        </Typography.Paragraph>
      )}
    </Space>
  )
}

export default Home
